// import { useEffect } from "react";
import PageDetail from "./component/PageDetail"
  const Index =({handleModalCallback,productSrc,closeShopifyModal})=> {
  //  useEffect(()=>{
  //   if (!window.opener) {
  //     handleModalCallback(productSrc,'Product_Variant_Modal')
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[])
    return (
      <div>
      <PageDetail closeShopifyModal={closeShopifyModal}/>
      </div>
    );
  }

  export default Index;